import UserType from './userType'
import SignIn from './signin'
import Identification from './forgotPassword/identification'
import ForgotPasswordOtp from './forgotPassword/forgotPasswordOtp'
import passwordReset from './forgotPassword/passwordReset'

export default [
    UserType,
    SignIn,
    Identification,
    ForgotPasswordOtp,
    passwordReset,
]